export const BOOKING_URL = "https://outlook.office.com/bookwithme/user/d377895d0a5f4fe1b3e2a4dab34f00e6@agc.ia.ca/meetingtype/xdG1EWY4A0yItqdqpZ1jTQ2?anonymous&ismsaljsauthenabled";
export const ADVISOR_EMAIL = "romain.tousse@agc.ia.ca";
export const BRAND = "Mon Projet Protégé";
export const TAGLINE = "Finances & Protection — Québec";

export const CONSENT_TEXT =
  "J'accepte que Mon Projet Protégé conserve mes coordonnées de façon confidentielle et sécurisée afin d'être contacté au sujet de ma protection financière. Conformément à la Loi 25, je peux retirer ce consentement en tout temps.";
